import * as taskTypesService from '../../../../../services/api/task-types-api';

export async function createTaskType(taskType) {
    return taskTypesService.addTaskType(taskType);
}

export async function editTaskType(taskType) {
    return taskTypesService.updateTaskType(taskType);
}

export async function getTaskTypeByType(type) {
    return (await taskTypesService.getTaskTypes(type))[0] ?? null;
}
